import script from "./CrudInscripciones.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudInscripciones.vue?vue&type=script&setup=true&lang=js"

import "./CrudInscripciones.vue?vue&type=style&index=0&id=5a4f6126&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a4f6126"]])

export default __exports__